var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoLongerNeeded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_389_9227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.64293 12.357L12.357 7.64298M15.8925 4.10744C19.1469 7.36181 19.1469 12.6382 15.8925 15.8926C12.6381 19.1469 7.36177 19.1469 4.1074 15.8926C0.853031 12.6382 0.853031 7.36181 4.1074 4.10744C7.36177 0.853074 12.6381 0.853075 15.8925 4.10744Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_389_9227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoLongerNeeded);
export default __webpack_public_path__ + "static/media/no-longer-needed.1ddca1d2acdb80d392f6e04f4b4718cd.svg";
export { ForwardRef as ReactComponent };